import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';

// --- Page Imports ---
import Dashboard from './Dashboard';
import LandingPage from './LandingPage'; 
import LiveDemoMap from './components/landing/LiveDemoMap';
import PrivacyPolicy from './pages/PrivacyPolicy'; 
import TermsOfService from './pages/TermsOfService'; 

import './App.css';

// --- HELPER: ScrollToTop ---
// This component listens to route changes and scrolls the window up
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// --- SECURITY: Protected Route Wrapper ---
// This ensures the Dashboard is ONLY visible when running locally (npm start).
// When built for production (npm run build), this route redirects to Home.
const ProtectedRoute = ({ children }: { children: React.ReactElement }) => {
  const isDevelopment = process.env.NODE_ENV === 'development';

  if (!isDevelopment) {
    // Redirect external/production users to the Landing Page
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      {/* Place the helper here so it works for all routes */}
      <ScrollToTop />
      
      <Routes>
        {/* Public Landing Page (Index) */}
        <Route path="/" element={<LandingPage />} />

        {/* SECRET / PROTECTED ROUTE for Internal Dashboard */}
        <Route 
          path="/app-internal-view" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />

        {/* Live Demo Route (Protected - Dev Only) */}
        <Route
          path="/demo"
          element={
            <ProtectedRoute>
              <LiveDemoMap />
            </ProtectedRoute>
          }
        />

        {/* Legal Pages */}
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
      </Routes>
    </Router>
  );
}

export default App;